export const MORNING_BRIEFING_START_HOUR = 6;
export const MORNING_BRIEFING_END_HOUR = 11;

export const EVENING_BRIEFING_START_HOUR = 17;
export const EVENING_BRIEFING_END_HOUR = 21;

export const MAX_BRIEFING_SHOWN_COUNT = 5;

export const CMMID_MORNING_BRIEFING = 'cmmuwjzeuoy';
export const CMMID_EVENING_BRIEFING = 'cmmtw8e0u46';
